import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { cookbookPath } from "@/lib/slug";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export async function saveCollection(title, items) {
  const { data } = await api.post("/search/save-collection", {
    title,
    recipe_ids: items.filter((i) => i.source !== "historical").map((i) => i.id),
    historical_ids: items.filter((i) => i.source === "historical").map((i) => i.id),
  });
  return data;
}

export const SaveCollectionDialog = ({ open, onOpenChange, defaultTitle, items }) => {
  const nav = useNavigate();
  const [title, setTitle] = useState(defaultTitle);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setTitle(defaultTitle); }, [open, defaultTitle]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await saveCollection(title.trim(), items);
      toast.success(`Saved ${data.saved} recipe${data.saved === 1 ? "" : "s"} to “${data.title}”`);
      if (data.limit_hit) toast.warning(data.limit_hit);
      onOpenChange(false);
      nav(cookbookPath(data.cookbook_id, data.title));
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't save");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-rf-cream max-w-md" data-testid="save-collection-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black text-rf-ink">Save as a cookbook</DialogTitle>
          <DialogDescription>
            Copies the {items.length} recipe{items.length === 1 ? "" : "s"} on screen into a new private cookbook. Your originals stay where they are.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input
            value={title} onChange={(e) => setTitle(e.target.value)} required maxLength={80}
            aria-label="Cookbook name" className="input-rf w-full" data-testid="save-collection-title"
          />
          <button type="submit" disabled={busy || !title.trim()} className="btn-orange w-full justify-center disabled:opacity-50" data-testid="save-collection-submit">
            {busy ? "Saving…" : "Create cookbook"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
